import React, { useEffect, useState } from "react";
import { Card, CardBody } from "./../../components/card/card.jsx";
import { CardFooter } from "react-bootstrap";
import { otherActivityNewRecord } from "../../config/apiSPA.js";
import { useNavigate } from "react-router-dom";
import ModalConfirm from "../../components/modal/modalConfirm.jsx";
import OtherActivityNewForm from "./otherActivityNewForm.jsx";
const initalEventData = {
  activity_id: "",
  instructor_id: "",
  date: "",
  remark: "",
};
function OtherActivityNew() {
  const [eventData, setEventData] = useState(initalEventData);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(true);
  const [spinner, setSpinner] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({ status: false, message: "" });
  const navigate = useNavigate();
  const getStatus = ({ activity_id, instructor_id, date }) => {
    if (!activity_id || !instructor_id || !date) return false;
    const today = new Date().toISOString().split("T")[0];
    return date <= today;
  };
  useEffect(() => {
    const status = getStatus(eventData);
    setSubmitBtnDisabled(!status);
  }, [eventData.activity_id, eventData.instructor_id, eventData.date]);
  const handleClickSubmit = (val) => {
    setSpinner(true);
    otherActivityNewRecord(val)
      .then((res) => navigate(`/other-activity/detail/${res.data}`))
      .catch((err) => {
        setSpinner(false);
        setModalConfirm({ status: true, message: err.message });
      });
  };
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="row">
              <div className="col-xl-9">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#/">Other Activity</a>
                  </li>
                  <li className="breadcrumb-item active">New</li>
                </ul>

                <h1 className="page-header">Input New Other Activity</h1>

                <hr className="mb-4" />

                <div id="formControls" className="mb-5">
                  <p>
                    Use this page to add new training data to the system. Please fill in all required fields and upload the dataset in a supported format. Accurate and well-structured data will help improve model performance and ensure
                    optimal results. Once completed, submit the form to save and process the training data.
                  </p>
                  <Card>
                    <CardBody className="pb-2">
                      <OtherActivityNewForm onUpdate={(val) => setEventData(val)} />
                    </CardBody>
                    <CardFooter>
                      {spinner ? (
                        <button type="button" className="btn btn-lg btn-outline-theme" disabled>
                          <i className="spinner-border spinner-border-sm"></i>
                        </button>
                      ) : (
                        <button onClick={() => handleClickSubmit(eventData)} type="button" disabled={submitBtnDisabled} className="btn btn-lg btn-outline-theme">
                          Submit
                        </button>
                      )}
                    </CardFooter>
                  </Card>
                </div>
              </div>
              <div className="col-xl-3"></div>
            </div>
          </div>
        </div>
      </div>
      <ModalConfirm
        show={modalConfirm.status}
        theme={"danger"}
        title={"Warning !!"}
        text={modalConfirm.message}
        onHide={() => setModalConfirm((a) => ({ ...a, status: false }))}
        clicked={() => setModalConfirm((a) => ({ ...a, status: false }))}
      />
    </>
  );
}

export default OtherActivityNew;
